import { useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { appGetHubById } from '../../store/hubs'
import { useDispatch, useSelector } from 'react-redux'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

function Header() {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const hubId = localStorage.getItem('hubId')
	const permissionOfHub = localStorage.getItem('permissionOfHub')

	const hubDetails = useSelector(state => state.hubReducer.hubDetails)

	const hubAdmin = useMemo(() => {
		const data = localStorage.getItem('hubAdmin')

		//	console.log('hubAdmin from localStorage:', JSON.parse(data))
		if (!data || data === 'null') return null
		try {
			return JSON.parse(data)
		} catch {
			return null
		}
	}, [])

	const adminName =
		hubAdmin?.name || [hubAdmin?.firstName, hubAdmin?.lastName].filter(Boolean).join(' ')

	useEffect(() => {
		if (hubId || permissionOfHub) {
			dispatch(appGetHubById(hubId || permissionOfHub))
		}
	}, [])

	function handleLogout() {
		localStorage.clear()
		navigate('/', { replace: true })
	}

	return (
		<header className="topnavbar-wrapper">
			<nav className="navbar topnavbar">
				<a className="navbar-brand" href="#/" />

				<div className="brand-logo" style={{ marginLeft: '3.25rem' }}>
					<img
						className="img-fluid"
						src="/img/logo1.png"
						alt="App Logo"
						style={{ width: '60px', height: '40px' }}
					/>
				</div>

				<ul className="navbar-nav mr-auto flex-row" style={{ marginLeft: '3.25rem' }}>
					<li className="nav-item">
						<a
							className="nav-link d-none d-md-block p-0"
							href="#"
							data-toggle-state="aside-collapsed"
						>
							<em className="fas fa-bars"></em>
						</a>
					</li>

					<li>
						<div
							style={{
								position: 'absolute',
								left: '50%',
								top: '50%',
								transform: 'translate(-50%, -50%)',
								fontSize: '1.25rem',
								color: '#fff',
								pointerEvents: 'none',
							}}
						>
							Community : {toCamelCase(hubDetails?.name)}
						</div>
					</li>
				</ul>

				{hubAdmin && (
					<ul className="navbar-nav flex-row align-items-center mr-3 text-white">
						<li className="nav-item d-flex align-items-center">
							{/* <img
								src={hubAdmin?.profilePic || '/img/user.png'}
								alt="Profile"
								style={{
									width: 50,
									height: 50,
									borderRadius: '50%',
									objectFit: 'cover',
									marginRight: 10,
									border: '2px solid #fff',
								}}
							/> */}

							<PostPreview value={hubAdmin?.profilePic || '/img/user.jpg'} />

							<div style={{ lineHeight: 1.2, marginLeft: '8px' }}>
								<strong style={{ fontSize: '14px' }}>{adminName}</strong>
								<div className="text-white" style={{ fontSize: '14px' }}>
									{hubAdmin?.email}
								</div>
								<div className="text-white" style={{ fontSize: '14px' }}>
									{hubAdmin?.mobile}
								</div>
							</div>
						</li>
					</ul>
				)}

				<ul className="navbar-nav flex-row">
					<li className="nav-item">
						<span className="nav-link" onClick={handleLogout} style={{ cursor: 'pointer' }}>
							Log Out
						</span>
					</li>
				</ul>
			</nav>
		</header>
	)
}

export default Header
